export class TagModel {
    constructor(public id: number, public text: string, public active: boolean) { }
}

export class TagModelJobDescriptions {
  constructor(public jobDescriptionId: number, public jobDescriptionName: string, public statusId: boolean) { }
}






// WEBPACK FOOTER //
// ./node_modules/@rx/forms/tag/tag.models.ts